const { TYPES } = require("./notification.type");

const initState = {
  notification: null,
};

const notificationReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_NOTIFICATION:
      return {
        ...state,
        notification: payload,
      };

    default:
      return state;
  }
};

export default notificationReducer;
